import { createSlice } from "@reduxjs/toolkit";
import { physician9 } from "../../Constant/Index";
import { notification } from "antd";

const AuthSlice = createSlice({
  name: "auth",
  initialState: {
    isLogin: false,
    loading: false,
    users: {},
    edituser: {},
    physician: {},
    userprofie: "",
    token: "",
    resetToken: "",
    role: "",
    // addressdetail: {},
    // galleryadd: [],
    sitesetting: {},
    orderdetail: {},
    physiciandetail: {},
    notifications: [],
    nearpharmcacy: {},
    prescriptiondetail: {},
    phyprescriptiondetail: {},
    operation: [],
  },
  reducers: {
    LOGIN_SUCCESS: (state, action) => {
      state.users = action.payload;
      state.loading = false;
      state.isLogin = true;
    },

    USER_TOKEN: (state, action) => {
      state.token = action.payload;
    },

    LOGOUT_SUCCESS: (state, action) => {
      state.token = "";
      state.users = {};
      state.operation = [];
      state.isLogin = false;
    },
    ROLE: (state, action) => {
      state.role = action.payload;
    },
    setResetToken: (state, action) => {
      state.resetToken = action.payload;
    },
    removeResetToken: (state) => {
      state.resetToken = null;
    },
    // SITE_SETTING: (state, action) => {
    //   state.sitesetting = action.payload;
    // },

    USER_DETAIL: (state, action) => {
      state.users = action.payload;
    },
    EDIT_USER: (state, action) => {
      state.edituser = action.payload;
    },
    GET_PHYSICIAN: (state, action) => {
      state.physician = action.payload;
    },
    USER_PROFILE: (state, action) => {
      state.userprofie = action.payload;
    },
    SITESETTING: (state, action) => {
      state.sitesetting = action.payload;
    },
    ORDER_DETAIL: (state, action) => {
      state.orderdetail = action.payload;
    },
    PHYSICIAN_DETAIL: (state, action) => {
      state.physiciandetail = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    GET_NEAR_PHARMACY: (state, action) => {
      state.nearpharmcacy = action.payload;
    },
    P_DETAIL: (state, action) => {
      state.prescriptiondetail = action.payload;
    },

    P_HDETAIL: (state, action) => {
      state.phyprescriptiondetail = action.payload;
    },
    OPERATION_HOUR: (state, action) => {
      state.operation = action.payload;
    },
  },
});

export const {
  LOGIN_SUCCESS,
  USER_TOKEN,
  LOGOUT_SUCCESS,
  ROLE,
  setResetToken,
  // SITE_SETTING,
  USER_DETAIL,
  removeResetToken,
  EDIT_USER,
  GET_PHYSICIAN,
  setCheckStatuspage,
  USER_PROFILE,
  SITESETTING,
  ORDER_DETAIL,
  PHYSICIAN_DETAIL,
  setNotifications,
  GET_NEAR_PHARMACY,
  P_DETAIL,
  P_HDETAIL,
  OPERATION_HOUR,
} = AuthSlice.actions;

export default AuthSlice.reducer;
